var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { alertErrorHandler, showError, showSuccess, showWarning, } from "@spike/notifications-action";
import { cleanPhoneNumberFormat } from "@spike/phone-utils";
import Axios from "axios";
import { serialize } from "object-to-formdata";
import { PAYMENTS_BOOKING_ALREADY_PROCESSED_ACTION_TYPE, PAYMENTS_BOOKING_LOCKED_ACTION_TYPE, PAYMENTS_CONFIRM_DEPOSIT_START_ACTION_TYPE, PAYMENTS_CONFIRM_DEPOSIT_SUCCESS_ACTION_TYPE, PAYMENTS_CONFIRM_START_ACTION_TYPE, PAYMENTS_CONFIRM_SUCCESS_ACTION_TYPE, PAYMENTS_DELETE_BANK_ACCOUNT_START_ACTION_TYPE, PAYMENTS_DELETE_BANK_ACCOUNT_SUCCESS_ACTION_TYPE, PAYMENTS_ERROR_ACTION_TYPE, PAYMENTS_FETCH_BANK_ACCOUNTS_START_ACTION_TYPE, PAYMENTS_FETCH_BANK_ACCOUNTS_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_PAYOUTS_START_ACTION_TYPE, PAYMENTS_FETCH_PAYOUTS_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_REFUNDS_BY_INVOICE_START_ACTION_TYPE, PAYMENTS_FETCH_REFUNDS_BY_INVOICE_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_REFUNDS_START_ACTION_TYPE, PAYMENTS_FETCH_REFUNDS_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_SHAREHOLDERS_START_ACTION_TYPE, PAYMENTS_FETCH_SHAREHOLDERS_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_START_ACTION_TYPE, PAYMENTS_FETCH_SUCCESS_ACTION_TYPE, PAYMENTS_GET_BUSINESS_PROFILE_START_ACTION_TYPE, PAYMENTS_GET_BUSINESS_PROFILE_SUCCESS_ACTION_TYPE, PAYMENTS_GET_DROP_IN_ADMIN_SESSION_START_ACTION_TYPE, PAYMENTS_GET_DROP_IN_ADMIN_SESSION_SUCCESS_ACTION_TYPE, PAYMENTS_GET_DROP_IN_CAMPAIGN_SESSION_START_ACTION_TYPE, PAYMENTS_GET_DROP_IN_CAMPAIGN_SESSION_SUCCESS_ACTION_TYPE, PAYMENTS_GET_DROP_IN_DEPOSIT_SESSION_START_ACTION_TYPE, PAYMENTS_GET_DROP_IN_DEPOSIT_SESSION_SUCCESS_ACTION_TYPE, PAYMENTS_GET_DROP_IN_SESSION_START_ACTION_TYPE, PAYMENTS_GET_DROP_IN_SESSION_SUCCESS_ACTION_TYPE, PAYMENTS_GET_DROP_IN_SUBSCRIPTION_SESSION_START_ACTION_TYPE, PAYMENTS_GET_DROP_IN_SUBSCRIPTION_SESSION_SUCCESS_ACTION_TYPE, PAYMENTS_GET_DROP_IN_CHANGE_PAYMENT_METHOD_SESSION_START_ACTION_TYPE, PAYMENTS_GET_DROP_IN_CHANGE_PAYMENT_METHOD_SESSION_SUCCESS_ACTION_TYPE, PAYMENTS_GET_ENROLLMENT_STATUS_START_ACTION_TYPE, PAYMENTS_GET_ENROLLMENT_STATUS_SUCCESS_ACTION_TYPE, PAYMENTS_GET_NEXT_PAYOUT_START_ACTION_TYPE, PAYMENTS_GET_NEXT_PAYOUT_SUCCESS_ACTION_TYPE, PAYMENTS_GET_PAYMENT_METHODS_START_ACTION_TYPE, PAYMENTS_GET_PAYMENT_METHODS_SUCCESS_ACTION_TYPE, PAYMENTS_GET_PAYMENT_START_ACTION_TYPE, PAYMENTS_GET_PAYMENT_SUCCESS_ACTION_TYPE, PAYMENTS_GET_HOP_LINK_START_ACTION_TYPE, PAYMENTS_GET_HOP_LINK_SUCCESS_ACTION_TYPE, PAYMENTS_GET_PCI_START_ACTION_TYPE, PAYMENTS_GET_PCI_SUCCESS_ACTION_TYPE, PAYMENTS_GET_SALES_REPORTS_START_ACTION_TYPE, PAYMENTS_GET_SALES_REPORTS_SUCCESS_ACTION_TYPE, PAYMENTS_HAS_PAYMENTS_START_ACTION_TYPE, PAYMENTS_HAS_PAYMENTS_SUCCESS_ACTION_TYPE, PAYMENTS_REFUND_START_ACTION_TYPE, PAYMENTS_REFUND_SUCCESS_ACTION_TYPE, PAYMENTS_RESET_ACTION_TYPE, PAYMENTS_SAVE_BANK_ACCOUNT_START_ACTION_TYPE, PAYMENTS_SAVE_BANK_ACCOUNT_SUCCESS_ACTION_TYPE, PAYMENTS_SAVE_BUSINESS_PROFILE_START_ACTION_TYPE, PAYMENTS_SAVE_BUSINESS_PROFILE_SUCCESS_ACTION_TYPE, PAYMENTS_SAVE_DOCUMENTS_SHAREHOLDER_START_ACTION_TYPE, PAYMENTS_SAVE_DOCUMENTS_SHAREHOLDER_SUCCESS_ACTION_TYPE, PAYMENTS_SAVE_DOCUMENT_BANK_ACCOUNT_START_ACTION_TYPE, PAYMENTS_SAVE_DOCUMENT_BANK_ACCOUNT_SUCCESS_ACTION_TYPE, PAYMENTS_SAVE_DOCUMENT_BUSINESS_PROFILE_START_ACTION_TYPE, PAYMENTS_SAVE_DOCUMENT_BUSINESS_PROFILE_SUCCESS_ACTION_TYPE, PAYMENTS_SAVE_SHAREHOLDER_START_ACTION_TYPE, PAYMENTS_SAVE_SHAREHOLDER_SUCCESS_ACTION_TYPE, PAYMENTS_SEND_START_ACTION_TYPE, PAYMENTS_SEND_SUCCESS_ACTION_TYPE, PAYMENTS_SET_BANK_ACCOUNT_AS_PRIMARY_START_ACTION_TYPE, PAYMENTS_SET_BANK_ACCOUNT_AS_PRIMARY_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_PAYMENTS_WITHOUT_PAGINATION_START_ACTION_TYPE, PAYMENTS_FETCH_PAYMENTS_WITHOUT_PAGINATION_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_REFUNDS_WITHOUT_PAGINATION_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_REFUNDS_WITHOUT_PAGINATION_START_ACTION_TYPE, PAYMENTS_CREATE_PAYMENT_LINK_START_ACTION_TYPE, PAYMENTS_CREATE_PAYMENT_LINK_SUCCESS_ACTION_TYPE, PAYMENTS_RETRIEVE_PAYMENT_LINK_START_ACTION_TYPE, PAYMENTS_RETRIEVE_PAYMENT_LINK_SUCCESS_ACTION_TYPE, PAYMENTS_FETCH_PAYMENTS_CSV_DATA_START_ACTION_TYPE, PAYMENTS_FETCH_PAYMENTS_CSV_DATA_SUCCESS_ACTION_TYPE, PAYMENTS_ADD_PAYMENT_METHOD_START_ACTION_TYPE, PAYMENTS_ADD_PAYMENT_METHOD_SUCCESS_ACTION_TYPE, PAYMENTS_ADD_PAYMENT_METHOD_ERROR_ACTION_TYPE, GET_CLIENT_PAYMENT_METHODS_START_ACTION_TYPE, GET_CLIENT_PAYMENT_METHODS_SUCCESS_ACTION_TYPE, DELETE_CLIENT_PAYMENT_METHOD_START_ACTION_TYPE, DELETE_CLIENT_PAYMENT_METHOD_SUCCESS_ACTION_TYPE, SET_PRIMARY_CLIENT_PAYMENT_METHOD_START_ACTION_TYPE, SET_PRIMARY_CLIENT_PAYMENT_METHOD_SUCCESS_ACTION_TYPE } from "./PaymentsActionsTypes";
import { convertToBankAccount, convertToBusinessProfile, convertToDropIn, convertToDropInAdmin, convertToEnrollmentStatus, convertToNextPayout, convertToPayment, convertToPaymentMethod, convertToPaymentsResult, convertToPaymentsPageResult, convertToPayouts, convertToRefund, convertToRefundsResult, convertToRefundsPageResult, convertToSalesReports, convertToShareholder, convertToClientPaymentMethod, } from "./PaymentsConverter";
import axios from "axios";
var businessProfilesUrl = "/business_profiles";
var shareholdersUrl = "/shareholders";
var bankAccountsUrl = "/bank_accounts";
var newBankAccountsUrl = "marketplace/bank_accounts";
var dropInUrl = "/create_dropin";
var dropInDepositUrl = "/booking/create_dropin_deposit";
var dropInSubscriptionUrl = "/subscription/create_dropin";
var dropInChangePaymentMethodUrl = "/subscriptions";
var dropInCampaignUrl = "sms_campaign/create_dropin";
var dropOrderInUrl = "/terminal_order";
var confirmUrl = "confirm_payment";
var confirmDepositUrl = "/confirm_deposit_payment";
var sendUrl = "complete_transaction";
var pspEnabledUrl = "marketplace/psp_status";
var paymentsUrl = "payments";
var paymentsCsvUrl = "marketplace/transactions_report";
var refundsUrl = "refunds";
var invoicesUrl = "invoices";
var nextPayoutUrl = "marketplace/psp_balance";
var payoutsUrl = "marketplace/transactions_list";
var salesReportsUrl = "sales_report";
var pciUrl = "/marketplace/get_pci_questionnaire";
var paymentMethodsUrl = "/marketplace/get_stored_payment_methods";
var removePaymentMethodUrl = "payments/remove_recurring_card";
var hopLinkUrl = "marketplace/get_hop_link";
var createPayByLink = "/payment_links";
var customerPaymentMethodUrl = "/customers";
var unauthorized = 401;
var locked = 423;
var conflict = 409;
export var resetThunk = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(reset());
            return [2 /*return*/];
        });
    }); };
};
export var getBusinessProfileThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getBusinessProfileStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(businessProfilesUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getBusinessProfileSuccess(response.data
                        ? convertToBusinessProfile(response.data, apiClientWrapper.masterData)
                        : undefined));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, "Error getting business profile.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveBusinessProfileThunk = function (apiClientWrapper, businessProfile) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiMethod, requestBody, response, apiError_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    dispatch(saveBusinessProfileStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = businessProfile.id
                        ? "".concat(businessProfilesUrl, "/").concat(businessProfile.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(businessProfilesUrl, "?marketplace_id=").concat(marketplaceId);
                    apiMethod = businessProfile.id
                        ? apiClientWrapper.apiClient.patch
                        : apiClientWrapper.apiClient.post;
                    requestBody = {
                        id: businessProfile.id,
                        uuid: businessProfile.uuid,
                        marketplace_id: marketplaceId,
                        legal_name: businessProfile.legalName,
                        trade_name: businessProfile.tradeName,
                        ein_number: businessProfile.einNumber,
                        email: businessProfile.email,
                        website: businessProfile.website,
                        phone_type_id: (_a = businessProfile.phoneType) === null || _a === void 0 ? void 0 : _a.id,
                        phone: formatPhoneNumberToBeSaved(businessProfile.phoneNumber, (_c = (_b = businessProfile.address.country) === null || _b === void 0 ? void 0 : _b.alpha2) !== null && _c !== void 0 ? _c : ""),
                        address_street_number: businessProfile.address.streetNumber,
                        address_street: businessProfile.address.street,
                        address_city: businessProfile.address.city,
                        address_state: businessProfile.address.state,
                        address_zip_code: businessProfile.address.zipcode,
                        address_country: (_d = businessProfile.address.country) === null || _d === void 0 ? void 0 : _d.alpha2,
                        terms_of_service: true,
                    };
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiMethod(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _e.sent();
                    dispatch(saveBusinessProfileSuccess(convertToBusinessProfile(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess("Business Profile save successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _e.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        alertErrorHandler(apiError_2, dispatch, "Error saving Business Profile.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveDocumentBusinessProfileThunk = function (apiClientWrapper, businessProfileId, document) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, formData, options, prefix, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveDocumentBusinessProfileStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(businessProfilesUrl, "/").concat(businessProfileId, "/upload_document?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        business_profile_id: businessProfileId,
                        document: document,
                    };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    prefix = "business_profile";
                    formData = serialize(requestBody, options, formData, prefix);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveDocumentBusinessProfileSuccess(convertToBusinessProfile(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess("Business Profile Document save successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError("Error uploading the document. Please try again."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchShareholdersThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchShareholdersStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(shareholdersUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchShareholdersSuccess(response.data.map(function (shareholderDto) {
                        return convertToShareholder(shareholderDto, apiClientWrapper.masterData);
                    })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!Axios.isCancel(apiError_4)) {
                        dispatch(error());
                        alertErrorHandler(apiError_4, dispatch, "Error fetching shareholders.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveShareholderThunk = function (apiClientWrapper, shareholder) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiMethod, requestBody, response, apiError_5;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(saveShareholderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = shareholder.id
                        ? "".concat(shareholdersUrl, "/").concat(shareholder.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(shareholdersUrl, "?marketplace_id=").concat(marketplaceId);
                    apiMethod = shareholder.id
                        ? apiClientWrapper.apiClient.patch
                        : apiClientWrapper.apiClient.post;
                    requestBody = {
                        id: shareholder.id,
                        uuid: shareholder.uuid,
                        marketplace_id: marketplaceId,
                        gender_id: shareholder.gender.id,
                        first_name: shareholder.firstName,
                        last_name: shareholder.lastName,
                        email: shareholder.email,
                        date_of_birth: shareholder.dateOfBirth.format("YYYYMMDD"),
                        document_type_id: shareholder.documentType.id,
                        document_number: shareholder.documentNumber,
                        phone: formatPhoneNumberToBeSaved(shareholder.phoneNumber, (_b = (_a = shareholder.address.country) === null || _a === void 0 ? void 0 : _a.alpha2) !== null && _b !== void 0 ? _b : ""),
                        address_street_number: shareholder.address.streetNumber,
                        address_street: shareholder.address.street,
                        address_city: shareholder.address.city,
                        address_state: shareholder.address.state,
                        address_zip_code: shareholder.address.zipcode,
                        address_country: (_c = shareholder.address.country) === null || _c === void 0 ? void 0 : _c.alpha2,
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiMethod(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _d.sent();
                    dispatch(saveShareholderSuccess(convertToShareholder(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess("Shareholder save successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _d.sent();
                    if (!Axios.isCancel(apiError_5)) {
                        dispatch(error());
                        alertErrorHandler(apiError_5, dispatch, "Error saving Shareholder.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveDocumentsShareholderThunk = function (apiClientWrapper, shareholderId, frontDocument, backDocument, document) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, formData, options, prefix, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveDocumentsShareholderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(shareholdersUrl, "/").concat(shareholderId, "/upload_document?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        document: document === null ? "" : document,
                        document_front: frontDocument === null ? "" : frontDocument,
                        document_back: backDocument === null ? "" : backDocument,
                    };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    prefix = "shareholder";
                    formData = serialize(requestBody, options, formData, prefix);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveDocumentsShareholderSuccess(convertToShareholder(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess("Shareholder Documents save successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!Axios.isCancel(apiError_6)) {
                        dispatch(error());
                        dispatch(showError("Error uploading the document. Please try again."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchBankAccountsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, bankAccounts, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchBankAccountsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(newBankAccountsUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    bankAccounts = [];
                    if (Array.isArray(response.data)) {
                        bankAccounts = response.data;
                    }
                    else if (response.data && Object.keys(response.data).length === 0) {
                        console.warn("Empty response structure, returning empty object:", response.data);
                    }
                    dispatch(fetchBankAccountsSuccess(bankAccounts.map(function (bankAccountDto) {
                        return convertToBankAccount(bankAccountDto, apiClientWrapper.masterData);
                    })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!Axios.isCancel(apiError_7)) {
                        console.error("Error details:", apiError_7.response ? apiError_7.response.data : apiError_7.message);
                        dispatch(error());
                        alertErrorHandler(apiError_7, dispatch, "Error fetching bank accounts.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveBankAccountThunk = function (apiClientWrapper, bankAccount) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiMethod, requestBody, response, apiError_8;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(saveBankAccountStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = bankAccount.id
                        ? "".concat(bankAccountsUrl, "/").concat(bankAccount.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(bankAccountsUrl, "?marketplace_id=").concat(marketplaceId);
                    apiMethod = bankAccount.id
                        ? apiClientWrapper.apiClient.patch
                        : apiClientWrapper.apiClient.post;
                    requestBody = {
                        id: bankAccount.id,
                        uuid: bankAccount.uuid,
                        owner_name: bankAccount.ownerName,
                        account_number: bankAccount.accountNumber,
                        description: bankAccount.description,
                        routing_number: bankAccount.routingNumber,
                        account_type_id: (_a = bankAccount.accountType) === null || _a === void 0 ? void 0 : _a.id,
                        country_code: (_b = bankAccount.country) === null || _b === void 0 ? void 0 : _b.alpha2,
                        currency_id: (_c = bankAccount.currency) === null || _c === void 0 ? void 0 : _c.id,
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiMethod(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _d.sent();
                    dispatch(saveBankAccountSuccess(convertToBankAccount(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess("Bank Account save successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _d.sent();
                    if (!Axios.isCancel(apiError_8)) {
                        dispatch(error());
                        dispatch(showError("Error uploading the document. Please try again."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveDocumentBankAccountThunk = function (apiClientWrapper, bankAccountId, document) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, formData, options, prefix, response, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveDocumentBankAccountStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(bankAccountsUrl, "/").concat(bankAccountId, "/upload_document?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        document: document,
                    };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: false,
                    };
                    prefix = "bank_account";
                    formData = serialize(requestBody, options, formData, prefix);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveDocumentBankAccountSuccess(convertToBankAccount(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess("Bank Account Document save successfully"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    if (!Axios.isCancel(apiError_9)) {
                        dispatch(error());
                        alertErrorHandler(apiError_9, dispatch, "Error saving Bank Account Document.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropInSessionThunk = function (apiClientWrapper, invoiceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInSessionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(dropInUrl, "?marketplace_id=").concat(marketplaceId, "&invoice_id=").concat(invoiceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInSessionSuccess(convertToDropIn(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!Axios.isCancel(apiError_10)) {
                        dispatch(error());
                        alertErrorHandler(apiError_10, dispatch, "Error getting Drop In Session.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropInPaymenLinkSessionThunk = function (authToken, url) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInSessionStart());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.get(url, {
                            headers: {
                                Accept: "application/json",
                                Authorization: "Bearer ".concat(authToken),
                            },
                        })];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInSessionSuccess(convertToDropIn(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_11 = _a.sent();
                    if (!Axios.isCancel(apiError_11)) {
                        dispatch(error());
                        alertErrorHandler(apiError_11, dispatch, "Error getting Drop In Session.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropInCampaignSessionThunk = function (apiClientWrapper, campaignId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInCampaignSessionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(dropInCampaignUrl, "?marketplace_id=").concat(marketplaceId, "&id=").concat(campaignId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInCampaignSessionSuccess(convertToDropIn(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _a.sent();
                    if (!Axios.isCancel(apiError_12)) {
                        dispatch(error());
                        alertErrorHandler(apiError_12, dispatch, "Error getting Drop In Campaign Session.");
                        console.error({ apiError: apiError_12 });
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropAdminInSessionThunk = function (apiClientWrapper, adminInvoiceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInAdminSessionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(dropOrderInUrl, "/create_dropin?marketplace_id=").concat(marketplaceId, "&admin_invoice_id=").concat(adminInvoiceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInAdminSessionSuccess(convertToDropInAdmin(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_13 = _a.sent();
                    if (!Axios.isCancel(apiError_13)) {
                        dispatch(error());
                        alertErrorHandler(apiError_13, dispatch, "Error getting Admin Drop In Session.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropInDepositSessionThunk = function (apiClientWrapper, invoiceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInDepositSessionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(dropInDepositUrl, "?marketplace_id=").concat(marketplaceId, "&invoice_id=").concat(invoiceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInDepositSessionSuccess(convertToDropInAdmin(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_14 = _a.sent();
                    if (!Axios.isCancel(apiError_14)) {
                        dispatch(error());
                        alertErrorHandler(apiError_14, dispatch, "Error getting Depsit Drop In Session.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropInSubscriptionSessionThunk = function (apiClientWrapper, subscriptionId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_15;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInSubscriptionSessionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(dropInSubscriptionUrl, "?marketplace_id=").concat(marketplaceId, "&id=").concat(subscriptionId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInSubscriptionSessionSuccess(convertToDropInAdmin(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_15 = _a.sent();
                    if (!Axios.isCancel(apiError_15)) {
                        dispatch(error());
                        alertErrorHandler(apiError_15, dispatch, "Error getting Deposit Drop In Session.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropInChangePaymentMethodSessionThunk = function (apiClientWrapper, subscriptionId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInChangePaymentMethodSessionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(dropInChangePaymentMethodUrl, "/").concat(subscriptionId, "/change_payment_method?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInChangePaymentMethodSessionSuccess(convertToDropInAdmin(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_16 = _a.sent();
                    if (!Axios.isCancel(apiError_16)) {
                        dispatch(error());
                        alertErrorHandler(apiError_16, dispatch, "Error getting Change Payment Method Drop In Session.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var removeDropInPaymentMethod = function (apiClientWrapper, storedPaymentMethodId, invoiceId //Appointment or Deposit Invoice (AdminInvoice = undefined)
) {
    var marketplaceId = apiClientWrapper.marketplaceId;
    var url = "".concat(removePaymentMethodUrl, "?marketplace_id=").concat(marketplaceId);
    var body = {
        invoice_id: invoiceId,
        recurring_card_reference: storedPaymentMethodId,
    };
    return apiClientWrapper.apiClient
        .post(url, body, apiClientWrapper.requestConfig)
        .then(function (response) { return response.status === 200; });
};
export var getEnrollmentStatusThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_17;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getPSPEnabledStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(pspEnabledUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getPSPEnabledSuccess(convertToEnrollmentStatus(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_17 = _a.sent();
                    if (!Axios.isCancel(apiError_17)) {
                        dispatch(error());
                        alertErrorHandler(apiError_17, dispatch, "Error getting PSP enabled status.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var createConfirmUrl = function (baseUrl, invoiceId, marketplaceId) {
    return "".concat(baseUrl, "/").concat(invoiceId, "?marketplace_id=").concat(marketplaceId);
};
var createConfirmBodyRequest = function (paymentMethodId, sessionId) {
    return {
        invoice: {
            payment_type: paymentMethodId,
        },
        psp_session_id: sessionId,
    };
};
export var confirmThunk = function (apiClientWrapper, invoiceId, paymentMethodId, creditCardSessionId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiError_18;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch(confirmStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(createConfirmUrl(confirmUrl, invoiceId, marketplaceId), createConfirmBodyRequest(paymentMethodId, creditCardSessionId), apiClientWrapper.requestConfig)];
                case 2:
                    _c.sent();
                    dispatch(confirmSuccess());
                    return [3 /*break*/, 4];
                case 3:
                    apiError_18 = _c.sent();
                    if (!Axios.isCancel(apiError_18)) {
                        if (Axios.isAxiosError(apiError_18) &&
                            apiError_18.response &&
                            [unauthorized, locked].includes((_a = apiError_18.response) === null || _a === void 0 ? void 0 : _a.status)) {
                            dispatch(showWarning("Booking has been locked by ".concat(apiError_18.response.data.user.first_name, " ").concat(apiError_18.response.data.user.last_name)));
                            dispatch(setAsLocked());
                        }
                        else if (Axios.isAxiosError(apiError_18) &&
                            ((_b = apiError_18.response) === null || _b === void 0 ? void 0 : _b.status) === conflict) {
                            dispatch(showWarning(apiError_18.response.data.message));
                            dispatch(alreadyProcessed());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_18, dispatch, "Error confirming Payment.");
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var confirmDepositThunk = function (apiClientWrapper, invoiceId, paymentMethodId, creditCardSessionId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiError_19;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(confirmDepositStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(createConfirmUrl(confirmDepositUrl, invoiceId, marketplaceId), createConfirmBodyRequest(paymentMethodId, creditCardSessionId), apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(confirmDepositSuccess());
                    return [3 /*break*/, 4];
                case 3:
                    apiError_19 = _a.sent();
                    if (!Axios.isCancel(apiError_19)) {
                        dispatch(error());
                        alertErrorHandler(apiError_19, dispatch, "Error confirming deposit Payment.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var confirmAndSendThunk = function (apiClientWrapper, invoiceId, paymentMethodId, sendInvoice, sendReport, email, creditCardSessionId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiError_20, apiError_21;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch(confirmStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(createConfirmUrl(confirmUrl, invoiceId, marketplaceId), createConfirmBodyRequest(paymentMethodId, creditCardSessionId), apiClientWrapper.requestConfig)];
                case 2:
                    _c.sent();
                    dispatch(confirmSuccess());
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    dispatch(sendStart());
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(createSendUrl(sendUrl, invoiceId, marketplaceId), createSendRequest(sendInvoice, sendReport, email), apiClientWrapper.requestConfig)];
                case 4:
                    _c.sent();
                    dispatch(sendSuccess());
                    return [3 /*break*/, 6];
                case 5:
                    apiError_20 = _c.sent();
                    if (!Axios.isCancel(apiError_20)) {
                        dispatch(error());
                        alertErrorHandler(apiError_20, dispatch, "Error sending documento to pet parent.");
                    }
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 8];
                case 7:
                    apiError_21 = _c.sent();
                    if (!Axios.isCancel(apiError_21)) {
                        if (Axios.isAxiosError(apiError_21) &&
                            apiError_21.response &&
                            [unauthorized, locked].includes((_a = apiError_21.response) === null || _a === void 0 ? void 0 : _a.status)) {
                            dispatch(showWarning("Booking has been locked by ".concat(apiError_21.response.data.user.first_name, " ").concat(apiError_21.response.data.user.last_name)));
                            dispatch(setAsLocked());
                        }
                        else if (Axios.isAxiosError(apiError_21) &&
                            ((_b = apiError_21.response) === null || _b === void 0 ? void 0 : _b.status) === conflict) {
                            dispatch(showWarning(apiError_21.response.data.message));
                            dispatch(alreadyProcessed());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_21, dispatch, "Error confirming Payment.");
                        }
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
};
var createSendUrl = function (baseUrl, invoiceId, marketplaceId) {
    return "".concat(baseUrl, "/").concat(invoiceId, "?marketplace_id=").concat(marketplaceId);
};
var createSendRequest = function (sendInvoice, sendReport, email) {
    return {
        invoice: {
            send_invoice: sendInvoice,
            send_report: sendReport,
            customer_email: email,
        },
    };
};
export var sendThunk = function (apiClientWrapper, invoiceId, sendInvoice, sendReport, email) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, apiError_22;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(sendStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(createSendUrl(sendUrl, invoiceId, marketplaceId), createSendRequest(sendInvoice, sendReport, email), apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(sendSuccess());
                    if (sendInvoice || sendReport) {
                        dispatch(showSuccess("".concat(sendInvoice ? "Receipt" : "").concat(sendInvoice && sendReport ? " and " : "").concat(sendReport ? "Report" : "", " have been sent.")));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_22 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_22, dispatch, "Error sending documents to pet parent.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchThunk = function (apiClientWrapper, clientId, period, page, size) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_23;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(paymentsUrl, "?marketplace_id=").concat(marketplaceId, "&page=").concat(page, "&size=").concat(size, "&from=").concat((period === null || period === void 0 ? void 0 : period.from.format("YYYYMMDD")) || "", "&to=").concat((period === null || period === void 0 ? void 0 : period.to.format("YYYYMMDD")) || "", "&client_id=").concat(clientId === null ? "" : clientId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSuccess(convertToPaymentsPageResult(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace), response.data.total_amount));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_23 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_23, dispatch, "Error fetching payments.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchPaymentsWithoutPaginationThunk = function (apiClientWrapper, clientId, period) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_24;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchPaymentsWithoutPaginationStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(paymentsUrl, "?marketplace_id=").concat(marketplaceId, "&from=").concat((period === null || period === void 0 ? void 0 : period.from.format("YYYYMMDD")) || "", "&to=").concat((period === null || period === void 0 ? void 0 : period.to.format("YYYYMMDD")) || "", "&client_id=").concat(clientId === null ? "" : clientId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchPaymentsWithoutPaginationSuccess(convertToPaymentsResult(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_24 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_24, dispatch, "Error fetching payments.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchRefundsThunk = function (apiClientWrapper, clientId, period, page, size) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_25;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchRefundsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(refundsUrl, "?marketplace_id=").concat(marketplaceId, "&page=").concat(page, "&size=").concat(size, "&from=").concat((period === null || period === void 0 ? void 0 : period.from.format("YYYYMMDD")) || "", "&to=").concat((period === null || period === void 0 ? void 0 : period.to.format("YYYYMMDD")) || "", "&client_id=").concat(clientId === null ? "" : clientId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchRefundsSuccess(convertToRefundsPageResult(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace), response.data.total_balance));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_25 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_25, dispatch, "Error fetching refunds.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchRefundsWithoutPaginationThunk = function (apiClientWrapper, clientId, period) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_26;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchRefundsWithoutPaginationStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(refundsUrl, "?marketplace_id=").concat(marketplaceId, "&from=").concat((period === null || period === void 0 ? void 0 : period.from.format("YYYYMMDD")) || "", "&to=").concat((period === null || period === void 0 ? void 0 : period.to.format("YYYYMMDD")) || "", "&client_id=").concat(clientId === null ? "" : clientId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchRefundsWithoutPaginationSuccess(convertToRefundsResult(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_26 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_26, dispatch, "Error fetching refunds.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchRefundsByInvoiceThunk = function (apiClientWrapper, invoiceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_27;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchRefundsByInvoiceStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(invoicesUrl, "/").concat(invoiceId, "/refunds?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchRefundsByInvoiceSuccess(response.data.refunds.map(function (refundDto) {
                        return convertToRefund(refundDto, apiClientWrapper.masterData, apiClientWrapper.marketplace);
                    })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_27 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_27, dispatch, "Error fetching refunds by invoice.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var hasPaymentsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_28;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(hasPaymentsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(paymentsUrl, "?marketplace_id=").concat(marketplaceId, "&page=1&size=10");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(hasPaymentsSuccess(response.data.total_records > 0));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_28 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_28, dispatch, "Error has payments.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/*
export const fetchPayoutsThunk = (
  apiClientWrapper: ApiClientWrapper,
  page: number
): ThunkAction<void, RootState, null, PaymentsAction | NotificationsAction> => {
  return async (dispatch) => {
    dispatch(fetchPayoutsStart());

    const marketplaceId = apiClientWrapper.marketplaceId;
    const url = `${payoutsUrl}?marketplace_id=${marketplaceId}`;
    const body = { page };

    try {
      const response: AxiosResponse<PayoutsResponseDto> = await apiClientWrapper.apiClient.post(
        url,
        body,
        apiClientWrapper.requestConfig
      );
      dispatch(fetchPayoutsSuccess(convertToPayouts(response.data, page)));
    } catch (apiError: any) {
      dispatch(error());
      alertErrorHandler(apiError, dispatch, 'Error fetching payouts.');
    }
  };
};
*/
export var fetchPayoutsThunk = function (apiClientWrapper, page) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, body, response, normalizedResponse, apiError_29;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchPayoutsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(payoutsUrl, "?marketplace_id=").concat(marketplaceId);
                    body = { page: page };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    normalizedResponse = {
                        transactions: response.data.transactions || null,
                        items: response.data.items || null,
                        has_next_page: response.data.has_next_page,
                    };
                    dispatch(fetchPayoutsSuccess(convertToPayouts(normalizedResponse, page)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_29 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_29, dispatch, "Error fetching payouts.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getNextPayoutThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_30;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getNextPayoutStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(nextPayoutUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getNextPayoutSuccess(convertToNextPayout(response.data, apiClientWrapper.masterData)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_30 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_30, dispatch, "Error fetching next payout.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var refundThunk = function (apiClientWrapper, paymentId, amount, reason, disableSuccessAlert) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var showSuccessAlert, marketplaceId, url, requestBody, response, apiError_31;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(refundStart());
                    showSuccessAlert = !(disableSuccessAlert !== null && disableSuccessAlert !== void 0 ? disableSuccessAlert : false);
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(refundsUrl, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        payment_id: paymentId,
                        amount: amount.toString(),
                        reason: reason,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(refundSuccess(convertToPayment(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace)));
                    showSuccessAlert && dispatch(showSuccess("$".concat(amount, " refunded.")));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_31 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_31, dispatch, "Error refunding payment.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteBankAccountsThunk = function (apiClientWrapper, bankAccountId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiError_32;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteBankAccountStart(bankAccountId));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(bankAccountsUrl, "/").concat(bankAccountId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteBankAccountSuccess());
                    dispatch(showSuccess("Bank account deleted."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_32 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_32, dispatch, "Error deleting bank account.");
                    return [3 /*break*/, 4];
                case 4:
                    dispatch(fetchBankAccountsThunk(apiClientWrapper));
                    return [2 /*return*/];
            }
        });
    }); };
};
export var setBankAccountAsPrimaryThunk = function (apiClientWrapper, bankAccountId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiError_33;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setBankAccountAsPrimaryStart(bankAccountId));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(bankAccountsUrl, "/").concat(bankAccountId, "/set_primary?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, null, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(setBankAccountAsPrimarySuccess());
                    dispatch(showSuccess("Bank account set as primary."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_33 = _a.sent();
                    dispatch(fetchBankAccountsThunk(apiClientWrapper));
                    dispatch(error());
                    alertErrorHandler(apiError_33, dispatch, "Error setting bank account as primary.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var setBankAccountAsPrimaryNewProfileThunk = function (apiClientWrapper, bankAccountId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, apiError_34;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setBankAccountAsPrimaryStart(bankAccountId));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(newBankAccountsUrl, "/set_primary?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        bank_account_id: bankAccountId,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(setBankAccountAsPrimarySuccess());
                    dispatch(showSuccess("Bank account set as primary."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_34 = _a.sent();
                    dispatch(fetchBankAccountsThunk(apiClientWrapper));
                    dispatch(error());
                    alertErrorHandler(apiError_34, dispatch, "Error setting bank account as primary.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getSalesReportsThunk = function (apiClientWrapper, from, to) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_35;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getSalesReportsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(salesReportsUrl, "?marketplace_id=").concat(marketplaceId, "&start=").concat((from === null || from === void 0 ? void 0 : from.format("YYYY-MM-DD")) || "2010-01-01", "&end=").concat((to === null || to === void 0 ? void 0 : to.format("YYYY-MM-DD")) || "2025-01-01");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getSalesReportsSuccess(convertToSalesReports(response.data, from, to)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_35 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_35, dispatch, "Error getting sales reports.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getPciThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_36;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getPciStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(pciUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getPciSuccess(response.data.redirectUrl));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_36 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_36, dispatch, "Error getting pci url.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getPaymentMethodsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_37;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getPaymentMethodsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(paymentMethodsUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getPaymentMethodsSuccess(response.data.map(function (method) { return convertToPaymentMethod(method); })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_37 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_37, dispatch, "Error getting pci url.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getPaymentThunk = function (apiClientWrapper, paymentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_38;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getPaymentStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(paymentsUrl, "/").concat(paymentId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getPaymentSuccess(convertToPayment(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_38 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_38, dispatch, "Error getting payment.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getHopLinkThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_39;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getHopLinkStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(hopLinkUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getHopLinkSuccess(response.data.url));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_39 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_39, dispatch, "Error getting hop link.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var createPaymentLinkThunk = function (apiClientWrapper, invoiceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_40;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(createPaymentLinkStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(createPayByLink, "?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        invoice_id: invoiceId,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(createPaymentLinkSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_40 = _a.sent();
                    if (!Axios.isCancel(apiError_40)) {
                        dispatch(error());
                        alertErrorHandler(apiError_40, dispatch, "Error creating payment link.");
                    }
                    throw apiError_40;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var retrievePaymentLinkThunk = function (apiClientWrapper, paymentLinkUuid) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_41;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(retrievePaymentLinkStart());
                    url = "/api/public/v1/pay_by_link/".concat(paymentLinkUuid);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(retrievePaymentLinkSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_41 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_41, dispatch, "Error retrieving payment link.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchPyamentsCsvDataThunk = function (apiClientWrapper, from, to, clientId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_42;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchPaymentsCsvDataStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(paymentsCsvUrl, "?marketplace_id=").concat(marketplaceId, "&start_at=").concat((from === null || from === void 0 ? void 0 : from.format("YYYY-MM-DD")) || "", "&end_at=").concat((to === null || to === void 0 ? void 0 : to.format("YYYY-MM-DD")) || "", "&client_id=").concat(clientId || "");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchPaymentsCsvDataSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_42 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_42, dispatch, "Error fetching payments csv data.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getDropInAddPaymentMethodSessionThunk = function (apiClientWrapper, customerId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, response, apiError_43;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getDropInAddPaymentMethodSessionStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(customerPaymentMethodUrl, "/").concat(customerId, "/payment_methods?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        customer_id: customerId,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getDropInAddPaymentMethodSessionSuccess(convertToDropIn(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_43 = _a.sent();
                    if (!Axios.isCancel(apiError_43)) {
                        dispatch(getDropInAddPaymentMethodSessionError());
                        alertErrorHandler(apiError_43, dispatch, "Error getting Drop In Session.");
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getClientPaymentMethodsThunk = function (apiClientWrapper, customerId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_44;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getClientPaymentMethodsStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(customerPaymentMethodUrl, "/").concat(customerId, "/payment_methods?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getClientPaymentMethodsSuccess(response.data.map(convertToClientPaymentMethod)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_44 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_44, dispatch, "Error getting payment methods.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteClientPaymentMethodThunk = function (apiClientWrapper, customerId, cardId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, apiError_45;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteClientPaymentMethodStart(cardId));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(customerPaymentMethodUrl, "/").concat(customerId, "/payment_methods/").concat(cardId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteClientPaymentMethodSuccess());
                    dispatch(showSuccess("Card deleted successfully!"));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_45 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_45, dispatch, "Error deleting payment method.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var setPrimaryClientPaymentMethodThunk = function (apiClientWrapper, customerId, cardId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, requestBody, apiError_46;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setPrimaryClientPaymentMethodStart(cardId));
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(customerPaymentMethodUrl, "/").concat(customerId, "/payment_methods/").concat(cardId, "/set_primary?marketplace_id=").concat(marketplaceId);
                    requestBody = {
                        card_id: cardId,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(setPrimaryClientPaymentMethodSuccess());
                    return [3 /*break*/, 4];
                case 3:
                    apiError_46 = _a.sent();
                    dispatch(error());
                    alertErrorHandler(apiError_46, dispatch, "Error setting primary payment method.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: PAYMENTS_RESET_ACTION_TYPE,
    };
};
var getBusinessProfileStart = function () {
    return {
        type: PAYMENTS_GET_BUSINESS_PROFILE_START_ACTION_TYPE,
    };
};
var getBusinessProfileSuccess = function (businessProfile) {
    return {
        type: PAYMENTS_GET_BUSINESS_PROFILE_SUCCESS_ACTION_TYPE,
        payload: {
            businessProfile: businessProfile,
        },
    };
};
var saveBusinessProfileStart = function () {
    return {
        type: PAYMENTS_SAVE_BUSINESS_PROFILE_START_ACTION_TYPE,
    };
};
var saveBusinessProfileSuccess = function (businessProfile) {
    return {
        type: PAYMENTS_SAVE_BUSINESS_PROFILE_SUCCESS_ACTION_TYPE,
        payload: {
            businessProfile: businessProfile,
        },
    };
};
var saveDocumentBusinessProfileStart = function () {
    return {
        type: PAYMENTS_SAVE_DOCUMENT_BUSINESS_PROFILE_START_ACTION_TYPE,
    };
};
var saveDocumentBusinessProfileSuccess = function (businessProfile) {
    return {
        type: PAYMENTS_SAVE_DOCUMENT_BUSINESS_PROFILE_SUCCESS_ACTION_TYPE,
        payload: {
            businessProfile: businessProfile,
        },
    };
};
var fetchShareholdersStart = function () {
    return {
        type: PAYMENTS_FETCH_SHAREHOLDERS_START_ACTION_TYPE,
    };
};
var fetchShareholdersSuccess = function (shareholders) {
    return {
        type: PAYMENTS_FETCH_SHAREHOLDERS_SUCCESS_ACTION_TYPE,
        payload: {
            shareholders: shareholders,
        },
    };
};
var saveShareholderStart = function () {
    return {
        type: PAYMENTS_SAVE_SHAREHOLDER_START_ACTION_TYPE,
    };
};
var saveShareholderSuccess = function (shareholder) {
    return {
        type: PAYMENTS_SAVE_SHAREHOLDER_SUCCESS_ACTION_TYPE,
        payload: {
            shareholder: shareholder,
        },
    };
};
var saveDocumentsShareholderStart = function () {
    return {
        type: PAYMENTS_SAVE_DOCUMENTS_SHAREHOLDER_START_ACTION_TYPE,
    };
};
var saveDocumentsShareholderSuccess = function (shareholder) {
    return {
        type: PAYMENTS_SAVE_DOCUMENTS_SHAREHOLDER_SUCCESS_ACTION_TYPE,
        payload: {
            shareholder: shareholder,
        },
    };
};
var fetchBankAccountsStart = function () {
    return {
        type: PAYMENTS_FETCH_BANK_ACCOUNTS_START_ACTION_TYPE,
    };
};
var fetchBankAccountsSuccess = function (bankAccounts) {
    return {
        type: PAYMENTS_FETCH_BANK_ACCOUNTS_SUCCESS_ACTION_TYPE,
        payload: {
            bankAccounts: bankAccounts,
        },
    };
};
var saveBankAccountStart = function () {
    return {
        type: PAYMENTS_SAVE_BANK_ACCOUNT_START_ACTION_TYPE,
    };
};
var saveBankAccountSuccess = function (bankAccount) {
    return {
        type: PAYMENTS_SAVE_BANK_ACCOUNT_SUCCESS_ACTION_TYPE,
        payload: {
            bankAccount: bankAccount,
        },
    };
};
var saveDocumentBankAccountStart = function () {
    return {
        type: PAYMENTS_SAVE_DOCUMENT_BANK_ACCOUNT_START_ACTION_TYPE,
    };
};
var saveDocumentBankAccountSuccess = function (bankAccount) {
    return {
        type: PAYMENTS_SAVE_DOCUMENT_BANK_ACCOUNT_SUCCESS_ACTION_TYPE,
        payload: {
            bankAccount: bankAccount,
        },
    };
};
var getDropInSessionStart = function () {
    return {
        type: PAYMENTS_GET_DROP_IN_SESSION_START_ACTION_TYPE,
    };
};
var getDropInSessionSuccess = function (dropIn) {
    return {
        type: PAYMENTS_GET_DROP_IN_SESSION_SUCCESS_ACTION_TYPE,
        payload: {
            dropIn: dropIn,
        },
    };
};
var getDropInCampaignSessionStart = function () {
    return {
        type: PAYMENTS_GET_DROP_IN_CAMPAIGN_SESSION_START_ACTION_TYPE,
    };
};
var getDropInCampaignSessionSuccess = function (dropIn) {
    return {
        type: PAYMENTS_GET_DROP_IN_CAMPAIGN_SESSION_SUCCESS_ACTION_TYPE,
        payload: {
            dropIn: dropIn,
        },
    };
};
var getDropInAdminSessionStart = function () {
    return {
        type: PAYMENTS_GET_DROP_IN_ADMIN_SESSION_START_ACTION_TYPE,
    };
};
var getDropInAdminSessionSuccess = function (dropIn) {
    return {
        type: PAYMENTS_GET_DROP_IN_ADMIN_SESSION_SUCCESS_ACTION_TYPE,
        payload: {
            dropIn: dropIn,
        },
    };
};
var getDropInDepositSessionStart = function () {
    return {
        type: PAYMENTS_GET_DROP_IN_DEPOSIT_SESSION_START_ACTION_TYPE,
    };
};
var getDropInDepositSessionSuccess = function (dropIn) {
    return {
        type: PAYMENTS_GET_DROP_IN_DEPOSIT_SESSION_SUCCESS_ACTION_TYPE,
        payload: {
            dropIn: dropIn,
        },
    };
};
var getDropInSubscriptionSessionStart = function () {
    return {
        type: PAYMENTS_GET_DROP_IN_SUBSCRIPTION_SESSION_START_ACTION_TYPE,
    };
};
var getDropInSubscriptionSessionSuccess = function (dropIn) {
    return {
        type: PAYMENTS_GET_DROP_IN_SUBSCRIPTION_SESSION_SUCCESS_ACTION_TYPE,
        payload: {
            dropIn: dropIn,
        },
    };
};
var getDropInChangePaymentMethodSessionStart = function () {
    return {
        type: PAYMENTS_GET_DROP_IN_CHANGE_PAYMENT_METHOD_SESSION_START_ACTION_TYPE,
    };
};
var getDropInChangePaymentMethodSessionSuccess = function (dropIn) {
    return {
        type: PAYMENTS_GET_DROP_IN_CHANGE_PAYMENT_METHOD_SESSION_SUCCESS_ACTION_TYPE,
        payload: {
            dropIn: dropIn,
        },
    };
};
var getPSPEnabledStart = function () {
    return {
        type: PAYMENTS_GET_ENROLLMENT_STATUS_START_ACTION_TYPE,
    };
};
var getPSPEnabledSuccess = function (enrollmentStatus) {
    return {
        type: PAYMENTS_GET_ENROLLMENT_STATUS_SUCCESS_ACTION_TYPE,
        payload: {
            enrollmentStatus: enrollmentStatus,
        },
    };
};
var confirmStart = function () {
    return {
        type: PAYMENTS_CONFIRM_START_ACTION_TYPE,
    };
};
var confirmSuccess = function () {
    return {
        type: PAYMENTS_CONFIRM_SUCCESS_ACTION_TYPE,
    };
};
var confirmDepositStart = function () {
    return {
        type: PAYMENTS_CONFIRM_DEPOSIT_START_ACTION_TYPE,
    };
};
var confirmDepositSuccess = function () {
    return {
        type: PAYMENTS_CONFIRM_DEPOSIT_SUCCESS_ACTION_TYPE,
    };
};
var sendStart = function () {
    return {
        type: PAYMENTS_SEND_START_ACTION_TYPE,
    };
};
var sendSuccess = function () {
    return {
        type: PAYMENTS_SEND_SUCCESS_ACTION_TYPE,
    };
};
var fetchStart = function () {
    return {
        type: PAYMENTS_FETCH_START_ACTION_TYPE,
    };
};
var fetchSuccess = function (pageResult, total) {
    return {
        type: PAYMENTS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            payments: pageResult,
            total: total,
        },
    };
};
var fetchPaymentsWithoutPaginationStart = function () {
    return {
        type: PAYMENTS_FETCH_PAYMENTS_WITHOUT_PAGINATION_START_ACTION_TYPE,
    };
};
var fetchPaymentsWithoutPaginationSuccess = function (result) {
    return {
        type: PAYMENTS_FETCH_PAYMENTS_WITHOUT_PAGINATION_SUCCESS_ACTION_TYPE,
        payload: {
            paymentsWithoutPagination: result,
        },
    };
};
var fetchRefundsStart = function () {
    return {
        type: PAYMENTS_FETCH_REFUNDS_START_ACTION_TYPE,
    };
};
var fetchRefundsSuccess = function (pageResult, total) {
    return {
        type: PAYMENTS_FETCH_REFUNDS_SUCCESS_ACTION_TYPE,
        payload: {
            refunds: pageResult,
            total: total,
        },
    };
};
var fetchRefundsWithoutPaginationStart = function () {
    return {
        type: PAYMENTS_FETCH_REFUNDS_WITHOUT_PAGINATION_START_ACTION_TYPE,
    };
};
var fetchRefundsWithoutPaginationSuccess = function (result) {
    return {
        type: PAYMENTS_FETCH_REFUNDS_WITHOUT_PAGINATION_SUCCESS_ACTION_TYPE,
        payload: {
            refundsWithoutPagination: result,
        },
    };
};
var fetchRefundsByInvoiceStart = function () {
    return {
        type: PAYMENTS_FETCH_REFUNDS_BY_INVOICE_START_ACTION_TYPE,
    };
};
var fetchRefundsByInvoiceSuccess = function (refunds) {
    return {
        type: PAYMENTS_FETCH_REFUNDS_BY_INVOICE_SUCCESS_ACTION_TYPE,
        payload: {
            refunds: refunds,
        },
    };
};
var hasPaymentsStart = function () {
    return {
        type: PAYMENTS_HAS_PAYMENTS_START_ACTION_TYPE,
    };
};
var hasPaymentsSuccess = function (hasPayments) {
    return {
        type: PAYMENTS_HAS_PAYMENTS_SUCCESS_ACTION_TYPE,
        payload: {
            hasPayments: hasPayments,
        },
    };
};
var fetchPayoutsStart = function () {
    return {
        type: PAYMENTS_FETCH_PAYOUTS_START_ACTION_TYPE,
    };
};
var fetchPayoutsSuccess = function (payouts) {
    return {
        type: PAYMENTS_FETCH_PAYOUTS_SUCCESS_ACTION_TYPE,
        payload: {
            payouts: payouts,
        },
    };
};
var getNextPayoutStart = function () {
    return {
        type: PAYMENTS_GET_NEXT_PAYOUT_START_ACTION_TYPE,
    };
};
var getNextPayoutSuccess = function (nextPayout) {
    return {
        type: PAYMENTS_GET_NEXT_PAYOUT_SUCCESS_ACTION_TYPE,
        payload: {
            nextPayout: nextPayout,
        },
    };
};
var refundStart = function () {
    return {
        type: PAYMENTS_REFUND_START_ACTION_TYPE,
    };
};
var refundSuccess = function (payment) {
    return {
        type: PAYMENTS_REFUND_SUCCESS_ACTION_TYPE,
        payload: {
            payment: payment,
        },
    };
};
var deleteBankAccountStart = function (bankAccountId) {
    return {
        type: PAYMENTS_DELETE_BANK_ACCOUNT_START_ACTION_TYPE,
        payload: {
            bankAccountId: bankAccountId,
        },
    };
};
var deleteBankAccountSuccess = function () {
    return {
        type: PAYMENTS_DELETE_BANK_ACCOUNT_SUCCESS_ACTION_TYPE,
    };
};
var setBankAccountAsPrimaryStart = function (bankAccountId) {
    return {
        type: PAYMENTS_SET_BANK_ACCOUNT_AS_PRIMARY_START_ACTION_TYPE,
        payload: {
            bankAccountId: bankAccountId,
        },
    };
};
var setBankAccountAsPrimarySuccess = function () {
    return {
        type: PAYMENTS_SET_BANK_ACCOUNT_AS_PRIMARY_SUCCESS_ACTION_TYPE,
    };
};
var getSalesReportsStart = function () {
    return {
        type: PAYMENTS_GET_SALES_REPORTS_START_ACTION_TYPE,
    };
};
var getSalesReportsSuccess = function (salesReports) {
    return {
        type: PAYMENTS_GET_SALES_REPORTS_SUCCESS_ACTION_TYPE,
        payload: {
            salesReports: salesReports,
        },
    };
};
var getPciStart = function () {
    return {
        type: PAYMENTS_GET_PCI_START_ACTION_TYPE,
    };
};
var getPciSuccess = function (url) {
    return {
        type: PAYMENTS_GET_PCI_SUCCESS_ACTION_TYPE,
        payload: {
            url: url,
        },
    };
};
var getPaymentMethodsStart = function () {
    return {
        type: PAYMENTS_GET_PAYMENT_METHODS_START_ACTION_TYPE,
    };
};
var getPaymentMethodsSuccess = function (methods) {
    return {
        type: PAYMENTS_GET_PAYMENT_METHODS_SUCCESS_ACTION_TYPE,
        payload: {
            methods: methods,
        },
    };
};
var getPaymentStart = function () {
    return {
        type: PAYMENTS_GET_PAYMENT_START_ACTION_TYPE,
    };
};
var getPaymentSuccess = function (payment) {
    return {
        type: PAYMENTS_GET_PAYMENT_SUCCESS_ACTION_TYPE,
        payload: {
            payment: payment,
        },
    };
};
var getHopLinkStart = function () {
    return {
        type: PAYMENTS_GET_HOP_LINK_START_ACTION_TYPE,
    };
};
var getHopLinkSuccess = function (hopLink) {
    return {
        type: PAYMENTS_GET_HOP_LINK_SUCCESS_ACTION_TYPE,
        payload: {
            hopLink: hopLink,
        },
    };
};
var createPaymentLinkStart = function () { return ({
    type: PAYMENTS_CREATE_PAYMENT_LINK_START_ACTION_TYPE,
}); };
var createPaymentLinkSuccess = function (paymentLink) { return ({
    type: PAYMENTS_CREATE_PAYMENT_LINK_SUCCESS_ACTION_TYPE,
    payload: {
        paymentLink: paymentLink,
    },
}); };
var retrievePaymentLinkStart = function () { return ({
    type: PAYMENTS_RETRIEVE_PAYMENT_LINK_START_ACTION_TYPE,
}); };
var retrievePaymentLinkSuccess = function (paymentLink) { return ({
    type: PAYMENTS_RETRIEVE_PAYMENT_LINK_SUCCESS_ACTION_TYPE,
    payload: {
        paymentLink: paymentLink,
    },
}); };
var setAsLocked = function () {
    return {
        type: PAYMENTS_BOOKING_LOCKED_ACTION_TYPE,
    };
};
var alreadyProcessed = function () {
    return {
        type: PAYMENTS_BOOKING_ALREADY_PROCESSED_ACTION_TYPE,
    };
};
var fetchPaymentsCsvDataStart = function () {
    return {
        type: PAYMENTS_FETCH_PAYMENTS_CSV_DATA_START_ACTION_TYPE,
    };
};
var fetchPaymentsCsvDataSuccess = function (dto) {
    var csvFieldSeparator = ";";
    var headers = dto.length > 0 ? dto[0].split(csvFieldSeparator) : [];
    var records = dto.length > 1
        ? dto.slice(1).map(function (row) { return row.split(csvFieldSeparator); })
        : [];
    return {
        type: PAYMENTS_FETCH_PAYMENTS_CSV_DATA_SUCCESS_ACTION_TYPE,
        payload: {
            headers: headers,
            records: records,
        },
    };
};
var error = function () {
    return {
        type: PAYMENTS_ERROR_ACTION_TYPE,
    };
};
var formatPhoneNumberToBeSaved = function (phoneNumber, countryCode) {
    var cleanPhoneNumber = cleanPhoneNumberFormat(phoneNumber);
    return ["US", "CA"].includes(countryCode.toUpperCase()) &&
        !cleanPhoneNumber.startsWith("+")
        ? "+1" + cleanPhoneNumber
        : cleanPhoneNumber;
};
var getDropInAddPaymentMethodSessionStart = function () { return ({
    type: PAYMENTS_ADD_PAYMENT_METHOD_START_ACTION_TYPE
}); };
var getDropInAddPaymentMethodSessionSuccess = function (dropIn) {
    return {
        type: PAYMENTS_ADD_PAYMENT_METHOD_SUCCESS_ACTION_TYPE,
        payload: {
            dropIn: dropIn
        }
    };
};
var getDropInAddPaymentMethodSessionError = function () { return ({
    type: PAYMENTS_ADD_PAYMENT_METHOD_ERROR_ACTION_TYPE,
}); };
var getClientPaymentMethodsStart = function () { return ({
    type: GET_CLIENT_PAYMENT_METHODS_START_ACTION_TYPE,
}); };
var getClientPaymentMethodsSuccess = function (clientPaymentMethods) { return ({
    type: GET_CLIENT_PAYMENT_METHODS_SUCCESS_ACTION_TYPE,
    payload: {
        clientPaymentMethods: clientPaymentMethods
    },
}); };
var deleteClientPaymentMethodStart = function (clientPaymentMethodId) { return ({
    type: DELETE_CLIENT_PAYMENT_METHOD_START_ACTION_TYPE,
    payload: {
        clientPaymentMethodId: clientPaymentMethodId
    },
}); };
var deleteClientPaymentMethodSuccess = function () { return ({
    type: DELETE_CLIENT_PAYMENT_METHOD_SUCCESS_ACTION_TYPE,
}); };
var setPrimaryClientPaymentMethodStart = function (cardId) { return ({
    type: SET_PRIMARY_CLIENT_PAYMENT_METHOD_START_ACTION_TYPE,
    payload: {
        cardId: cardId
    },
}); };
var setPrimaryClientPaymentMethodSuccess = function () { return ({
    type: SET_PRIMARY_CLIENT_PAYMENT_METHOD_SUCCESS_ACTION_TYPE,
}); };
